export default __webpack_public_path__ + "static/media/pluss.f3348841.svg";